import React, { useRef } from 'react';
import { Modal, Button, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Alert from '../../../../../components/Alert';

const AddModal = ({ open, onHide, onShow, error, isLoadingSubmit, onSubmit }) => {
  const formNode = useRef(null);

  const onSubmitForm = (event) => {
    event.preventDefault();
    const current = formNode?.current;
    onSubmit?.(current?.link?.value);
  };

  return (
    <Modal show={open} onHide={onHide} onShow={onShow} backdrop="static" className="modal-md-custom">
      {isLoadingSubmit && <div className="modal-loader-small" />}

      <Modal.Header closeButton>
        <Modal.Title>Add provider</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert text={error} />}

        <form onSubmit={onSubmitForm} ref={formNode}>
          <FormGroup>
            <ControlLabel htmlFor="link">Provider URL</ControlLabel>
            <FormControl id="link" type="text" name="link" autoFocus />
          </FormGroup>
        </form>
      </Modal.Body>
      <Modal.Footer className="custom__modal-footer">
        <Button bsStyle="primary" type="submit" disabled={isLoadingSubmit} onClick={onSubmitForm}>
          <span>Add provider</span>
        </Button>
        <Button
          onClick={() => {
            onHide();
          }}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

AddModal.propTypes = {
  error: PropTypes.string,
  open: PropTypes.bool,
  isLoadingSubmit: PropTypes.bool,
  onHide: PropTypes.func,
  onShow: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default AddModal;
